import React,{useEffect,useState} from 'react';
import { NavLink } from 'react-router-dom'
import { Row, Col, Container, Nav, Tab, Accordion } from "react-bootstrap";
import ProfileInformation from "../ProfileInformation/ProfileInformation";
import CorporateProfile from "../CorporateProfile/CorporateProfile";
import ShippingAddress from "../ShippingAddress/ShippingAddress";
import Catalog from "../Catalog/Catalog";
import DraftPool from "../DraftPool/DraftPool";
import CostCenter from "../CostCenter/CostCenter";
import Budget from "../Budget/Budget";
import CostCenterApprover from "../CostCenterApprover/CostCenterApprover";
import Staff from "../Staff/Staff";
import CostCenterDetails from "../CostCenterDetails/CostCenterDetails";
import Contract from "../Contract/Contract";
import MyOrder from "../MyOrder/MyOrder";
import DeliveryOrder from "../DeliveryOrder";
import MyTemplate from "../MyTemplate/MyTemplate";
import MyReturn from "../MyReturn/MyReturn";
import MyWishlist from "../MyWishlist/MyWishlist";
import ContractDetails from "../ContractDetails/ContractDetails";
import CatalogDetails from "../CatalogDetails/CatalogDetails";
import ProductMapping from "../ProductMapping/ProductMapping";
import MyRequest from "../MyRequest";
import MyInvoice from "../MyInvoices/MyInvoices";
import CorporateProfileGeneral from "../CorporateProfile/CorporateProfileGeneral";
import Dashboard from "../Dashboard/Dashboard";
import Reports from "../Report/Reports";
import "./MyAccount.styles.css";
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import MyWallet from '../MyWallet';
import MyReviews from '../MyReview';

const MyAccount = () => {
  
  const [searchParams, setSearchParams] = useSearchParams();
  const [logedInUser, setLogedInUser] = useState(false);
  const [acccountDetails, setacccountDetails] = useState(false);
  const [defaultActiveKey, setdefaultActiveKey] = useState(false);

  const getAccountDetails= async (userEmail, role) => {
    await Axios.get('/profile/userprofile?username='+userEmail)
    .then(function (response) {
    if(response.data && response.data.profile){
      response.data.profile.role=role;
        setacccountDetails(response.data.profile);
    }})
    .catch(function (error) {
      setacccountDetails(false);
    });
};
  
  useEffect(() => {
    const user=AuthVerify.getUser();
    if(user && user.role){
      // setUserPermissions(user.permissions);
      getAccountDetails(user.email,user.role);
      setLogedInUser(user.role);
    }
  }, [])

    useEffect(async () => {
      if(searchParams.get("activeKey"))setdefaultActiveKey(searchParams.get("activeKey"));
      else setdefaultActiveKey("dashboard");
  }, [searchParams])
  
  return (
    <>
      <div className="main-container col2-right-layout">
        <Container className="main">
          {defaultActiveKey && 
            <Tab.Container id="left-tabs-example" defaultActiveKey={defaultActiveKey}>
              <Row>
                <Col sm={3} xs={12} md={3}>
                  <div className="block block-account">
                    <div className="block-title">My Account</div>
                    <div className="block-account">
                      <p><span class="fa fa-user" style={{ color:'var(--navBG)'}}></span>: {acccountDetails?.username}</p>
                      {acccountDetails?.arname && <p><span class="fa fa-building" style={{ color:'var(--navBG)'}}></span>: {acccountDetails?.arname}</p>}
                    </div>
                    <div className="block-content">
                      <Nav Nav variant="pills" className="flex-column">
                        {AuthVerify.getPermissions("Dashboard")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="dashboard">Dashboard</Nav.Link>
                        </Nav.Item>
                        }
                        <Accordion>
                          {logedInUser && logedInUser=="Corporate"?
                            <>
                            <Accordion.Item eventKey="0">
                              <Accordion.Header>{acccountDetails.role} Setting</Accordion.Header>
                              <Accordion.Body>
                              {AuthVerify.getPermissions("MyProfile")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="MyGeneralProfile">My Profile</Nav.Link>
                                </Nav.Item>
                              }
                              {AuthVerify.getPermissions("CorporateProfile")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="corporateprofile">
                                  {acccountDetails.role} Profile
                                  </Nav.Link>
                                </Nav.Item>
                                }
                                {AuthVerify.getPermissions("ShippingAddress")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="shippingAddress">
                                    Shipping Address
                                  </Nav.Link>
                                </Nav.Item>
                                }
                                {AuthVerify.getPermissions("Staff")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="staff">Staff</Nav.Link>
                                </Nav.Item>
                                }
                                {/* {AuthVerify.getPermissions("MyProfile")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="Group">Group</Nav.Link>
                                </Nav.Item>
                                } */}
                                {AuthVerify.getPermissions("CostCenter")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="Cost">Cost Center</Nav.Link>
                                </Nav.Item>}
                                {AuthVerify.getPermissions("Catalog")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="Catalog">Catalog</Nav.Link>
                                </Nav.Item>}
                                {AuthVerify.getPermissions("Budget")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="Budget">Budget</Nav.Link>
                                </Nav.Item>}
                                {AuthVerify.getPermissions("ProductMapping")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="ProductMapping">
                                    Product Mapping
                                  </Nav.Link>
                                  {/* <NavLink to="/productMapping" className={"nav-link"}> 
                                    Product Mapping 
                                  </NavLink> */}
                                </Nav.Item>}
                                {AuthVerify.getPermissions("ChartOfAccount")?.menuaccess && 
                                <Nav.Item>
                                  <Nav.Link eventKey="Chart">
                                    Chart of Accounts
                                  </Nav.Link>
                                </Nav.Item>}
                              </Accordion.Body>
                            </Accordion.Item>
                            {/* <Accordion.Item eventKey="1">
                              <Accordion.Header>Approval Setting</Accordion.Header>
                              <Accordion.Body>
                                <Nav.Item>
                                  <Nav.Link eventKey="CostCenterApprover">Cost Center</Nav.Link>
                                </Nav.Item>
                              </Accordion.Body>
                            </Accordion.Item> */}
                            </>:<></>
                          }
                          {logedInUser && logedInUser=="Individual"?
                          <>
                          <Accordion.Item eventKey="1">
                            <Accordion.Header>My Setting</Accordion.Header>
                            <Accordion.Body>
                            {AuthVerify.getPermissions("MyProfile")?.menuaccess && 
                              <Nav.Item>
                                <Nav.Link eventKey="Profile">Profile</Nav.Link>
                              </Nav.Item>}
                              {AuthVerify.getPermissions("ShippingAddress")?.menuaccess && 
                              <Nav.Item>
                                  <Nav.Link eventKey="shippingAddress">
                                    Shipping Address
                                  </Nav.Link>
                                </Nav.Item>}
                                {/* {AuthVerify.getPermissions("MyProfile")?.menuaccess && 
                              <Nav.Item>
                                <Nav.Link eventKey="Templates">
                                  Order Templates
                                </Nav.Link>
                              </Nav.Item>} */}
                              {/* {AuthVerify.getPermissions("MyProfile")?.menuaccess && 
                              <Nav.Item>
                                <Nav.Link eventKey="Favorites">
                                  Favorites
                                </Nav.Link>
                              </Nav.Item>} */}
                            </Accordion.Body>
                          </Accordion.Item>
                          </>:<></>
                        }
                        </Accordion>
                        {AuthVerify.getPermissions("MyOrders")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="DraftPool">Draft Pool</Nav.Link>
                        </Nav.Item>}
                        {AuthVerify.getPermissions("MyOrders")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Orders">My Orders</Nav.Link>
                        </Nav.Item>}
                        {AuthVerify.getPermissions("DeliveryOrder")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="DeliveryOrder">Delivery Order</Nav.Link>
                        </Nav.Item>}
                        {AuthVerify.getPermissions("MyOrderTemplate")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Templates">My Templates</Nav.Link>
                        </Nav.Item>}
                        {AuthVerify.getPermissions("MyInvoices")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Invoices">My Invoices</Nav.Link>
                        </Nav.Item>}
                        {AuthVerify.getPermissions("MyReturns")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Returns">My Returns</Nav.Link>
                        </Nav.Item>}
                        {AuthVerify.getPermissions("MyWishlist")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Wishlist">My Wishlist</Nav.Link>
                        </Nav.Item>}
                        {/* <Nav.Item>
                          <Nav.Link eventKey="Drafts">My Drafts</Nav.Link>
                        </Nav.Item> */}
                        {logedInUser && logedInUser=="Corporate"?
                        <>
                        {AuthVerify.getPermissions("MyContracts")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Contracts">My Contracts</Nav.Link>
                        </Nav.Item>}
                        {AuthVerify.getPermissions("MyPayables")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Payables">My Payables</Nav.Link>
                        </Nav.Item>}
                        {AuthVerify.getPermissions("MyWallet")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Wallet">My Wallet</Nav.Link>
                        </Nav.Item>}
                        {/* {AuthVerify.getPermissions("MyProfile")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Request">My Request</Nav.Link>
                        </Nav.Item>
                        } */}
                        </>:<></>
                        }
                        {logedInUser && logedInUser=="Individual"?
                        <>
                        {/* {AuthVerify.getPermissions("MyProfile")?.menuaccess &&  */}
                        <Nav.Item>
                          <Nav.Link eventKey="Notification">
                            My Notification
                          </Nav.Link>
                        </Nav.Item>
                         {/* } */}
                        </>:<></>
                        }
                        {logedInUser && logedInUser=="Corporate"?<>
                        {AuthVerify.getPermissions("MyReviews")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Reviews">My Reviews</Nav.Link>
                        </Nav.Item>
                         }
                         {AuthVerify.getPermissions("MyRequests")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Request">My Requests</Nav.Link>
                        </Nav.Item>
                         }
                        {AuthVerify.getPermissions("Report")?.menuaccess && 
                        <Nav.Item>
                          <Nav.Link eventKey="Analysis">Report Analysis</Nav.Link>
                        </Nav.Item>}</>:<></>
                        }
                        <Nav.Item>
                          <NavLink to="/logout" className={"nav-link"} style={{ fontSize: "15px" }}> 
                            <i className="icon-logout icons" style={{ fontSize: "13px" }}></i> Logout 
                          </NavLink>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </div>
                </Col>
                <Col sm={9} xs={12} md={9}>
                  <Tab.Content>
                    <Tab.Pane eventKey="dashboard">
                      <Dashboard acccountDetails={acccountDetails}/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="corporateprofile">
                      <CorporateProfile />
                    </Tab.Pane>
                    <Tab.Pane eventKey="shippingAddress">
                      <ShippingAddress key={Date.now()}/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="MyGeneralProfile">
                      <CorporateProfileGeneral />
                    </Tab.Pane>
                    <Tab.Pane eventKey="staff">
                    <Staff />
                    </Tab.Pane>
                    <Tab.Pane eventKey="Group">
                      <h1>Group</h1>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Cost">
                      {/* <h1>Cost Center</h1> */}
                      <CostCenter/>
                      {/* <CostCenterDetails/> */}
                    </Tab.Pane>
                    <Tab.Pane eventKey="CostCenterApprover">
                      <CostCenterApprover/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Catalog">
                      <Catalog/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="CatalogDetails">
                      <CatalogDetails/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Budget">
                      <Budget/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="ProductMapping">
                      <ProductMapping/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Chart">
                      <h1>Chart of Accounts</h1>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Profile">
                      <ProfileInformation />
                    </Tab.Pane>
                    <Tab.Pane eventKey="Favorites">
                      <h1>Favorites</h1>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Contracts">
                      <Contract/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="DraftPool">
                      <DraftPool/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Orders">
                      <MyOrder/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="DeliveryOrder">
                      <DeliveryOrder/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Templates">
                      <MyTemplate/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Returns">
                      <MyReturn/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Wishlist">
                      <MyWishlist/>
                    </Tab.Pane>
                    {/* <Tab.Pane eventKey="Drafts">
                      <Draft/>
                    </Tab.Pane> */}
                    <Tab.Pane eventKey="Invoices">
                      <MyInvoice/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Payables">
                      <h1>My Payables</h1>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Wallet">
                      <MyWallet/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Notification">
                      <h1>My Notification</h1>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Request">
                      <MyRequest/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Reviews">
                      <MyReviews/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Analysis">
                      {/* <h1>Report Analysis</h1> */}
                      <Reports/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Logout">
                      <h1>logout</h1>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          }
        </Container>
      </div>
    </>
  );
};

export default MyAccount;
